
	jQuery(document).ready(function($) {
		/* clubs pagina */
		if ($('#clubs').length) {
			var clubs = new Array();
			var regios = new Array();
			// alle links uit de html halen en in array stoppen
			$('#clubs a').each(function() {
				a = $(this).detach();
				clubs.push(a);
			});
			// alle links overlopen, en array met regio-afkortingen opstellen
			$(clubs).each(function() {
				regio = $(this).attr('class');
				if (jQuery.inArray(regio,regios) == -1) {
					regios.push(regio);
				}
			});
			console.log(regios);
			regios.sort();
			// alle regio-afkortingen overlopen en array met titels opstellen
			$(regios).each(function() {
				if ($(this)[0] == 'a') {
					$('#clubs').append('<div id="a"><h4>Antwerpen</h4><ul></ul></div>');
				}
				if ($(this)[0] == 'o') {
					$('#clubs').append('<div id="o"><h4>Oost-Vlaanderen</h4><ul></ul></div>');
				}
				if ($(this)[0] == 'w') {
					$('#clubs').append('<div id="w"><h4>West-Vlaanderen</h4><ul></ul></div>');
				}
				if ($(this)[0] == 'v') {
					$('#clubs').append('<div id="v"><h4>Vlaams-Brabant</h4><ul></ul></div>');
				}
				if ($(this)[0] == 'n') {
					$('#clubs').append('<div id="n"><h4>Nederland</h4><ul></ul></div>');
				}
				if ($(this)[0] == 'l') {
					$('#clubs').append('<div id="l"><h4>Limburg</h4><ul></ul></div>');
				}
			})
			$(clubs).each(function() {
				regio = $(this).attr('class');
				if (regio == "a") {
					$('#a ul').append('<li><a href="'+$(this)[0]+'">'+ $(this).html() +'</a></li>');
				}
				if (regio == "o") {
					$('#o ul').append('<li><a href="'+$(this)[0]+'">'+ $(this).html() +'</a></li>');
				}
				if (regio == "w") {
					$('#w ul').append('<li><a href="'+$(this)[0]+'">'+ $(this).html() +'</a></li>');
				}
				if (regio == "v" || regio == "b") {
					$('#v ul').append('<li><a href="'+$(this)[0]+'">'+ $(this).html() +'</a></li>');
				}
				if (regio == "n") {
					$('#n ul').append('<li><a href="'+$(this)[0]+'">'+ $(this).html() +'</a></li>');
				}
				if (regio == "l") {
					$('#l ul').append('<li><a href="'+$(this)[0]+'">'+ $(this).html() +'</a></li>');
				}
			});
		};
		if($('#tabs').length) { /* activiteit beschrijving/fotoalbum */
			$( "#tabs" ).tabs();
			if ($('#plusgallery').length) {
				$('#plusgallery').plusGallery();
			}
		}
	});
	
